import type {
  CustomerDocAccessRuleChange,
  CustomerDocumentationAccess,
} from "@xop-any-time/shared";

import { api } from "../../../lib/api.js";

/**
 * A customer's documentation access, through this app's BFF
 * (`/api/customers/:id/documentation-access` → portal-api). `customerId` is the
 * CRM customer id the customer page already has.
 *
 * Both calls answer with the WHOLE state, so a save needs no follow-up read:
 * the page takes the answer as-is.
 */
export const customerDocAccessKey = (customerId: string) =>
  ["customer-documentation-access", customerId] as const;

export function getCustomerDocAccess(customerId: string): Promise<CustomerDocumentationAccess> {
  return api<CustomerDocumentationAccess>(
    `/api/customers/${encodeURIComponent(customerId)}/documentation-access`,
  );
}

export function saveCustomerDocAccess(
  customerId: string,
  rules: CustomerDocAccessRuleChange[],
): Promise<CustomerDocumentationAccess> {
  return api<CustomerDocumentationAccess>(
    `/api/customers/${encodeURIComponent(customerId)}/documentation-access/rules`,
    { method: "PUT", body: { rules } },
  );
}
